import React, { Component } from 'react';

import Ask from './Ask';

export default class FaqRow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activePopupAsk: false
    }
  }

  render() {
    const { faq } = this.props;

    return (
      <div>
        <section className="container-this-help">
          <section className={ this.state.activePopupAsk ? "this-help disabled" : "this-help" }>
            <img src={require('../img/icon-question-help.svg')} alt="" className="icon-question-help"/>
            <h6>Essa resposta te ajudou?</h6>
            <div>
              <button className="yes" title="Sim" onClick={this.props.setActivityKey}>Sim</button>
              <button className="no" title="Não" onClick={() => this.setState({ activePopupAsk: true })}>Não</button>
            </div>
          </section>
        </section>

        { this.state.activePopupAsk && <Ask/> }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FaqRow.js